<template>
  <div class="modal-body modal-body--big-pd">
    <h3 class="modal__title">
      Получить консультацию
    </h3>
    <h4 class="modal__title modal__title--small">
      Оставьте свой номер телефона, чтобы получить консультацию<br> по покупке квартиры.
    </h4>
    <form class="contact_form"  >
      <div class="row ">
        <div class="col-md-6">
          <input v-phone name="phone" type="text" class="form-control"  placeholder="Телефон"
                 v-model="form.phone"
                 :class="{'is-invalid': errors.has('phone')}"
          >
          <div class="invalid-feedback" v-text="errors.get('phone')"></div>
        </div>
      </div>
      <label class="modal__label">
        Дополнительные поля
      </label>
      <div class="row">
        <div class="mb-4 col-md-6">
          <input name="name" type="text" class="form-control" v-model="form.name"
                 :class="{'is-invalid': errors.has('name')}"
                 placeholder="Ваше имя" id="contact_name">
          <div class="invalid-feedback" v-text="errors.get('name')"></div>
        </div>

        <div class="col-md-6 mb-4">
          <input name="email" type="email" class="form-control"
                 v-model="form.email"
                 placeholder="Email"
                 :class="{'is-invalid': errors.has('email')}"
          >
          <div class="invalid-feedback" v-text="errors.get('email')"></div>
        </div>
      </div>

      <div class="mb-4">
        <textarea class="form-control" name="comment" v-model="form.comment"  placeholder="Комментарий"  rows="4"></textarea>
        <div class="invalid-feedback"></div>
      </div>
      <label class="form-checkbox">
                        <span class="modal__conf-text">
                            Я согласен(-на) с <a class="landing-questions__link" href="/privacy" target="_blank">политикой
                            конфиденциальности.</a>
                        </span>
        <input name="conf_policy" v-model="form.conf_agree" type="checkbox" class="form-checkbox__input"  :class="{'is-invalid': errors.has('conf_agree')}">
        <span class="form-checkbox__checkmark"></span>  <br>
        <div class="invalid-feedback invalid-feedback--conf_agree" v-text="errors.get('conf_agree')"></div>
      </label>
      <div class=" mb-2 mt-5">
        <button type="submit" class="btn button-red" @click.prevent="submitForm">Перезвоните мне</button>
      </div>
    </form>
  </div>
</template>
<script>
import { Errors } from  '@/common/services/errors.js';
export default {
  data() {
    return {

      form: {
        name:'',
        email:"",
        phone:"",
        comment:"",
        page_url:window.location.href,
        pageable_type:"App\\Models\\Flat",
        pageable_id:0,
        type: "Получить консультацию",
        conf_agree:true,
      },
      errors: new Errors(),
    }
  },
  methods: {
    submitForm() {
      axios.post('/contact/order', this.form)
          .then((response) => {
            if(response.data.errors) {
              this.errors.record(response.data.errors);
            } else {
              $('.contact_form_modal').modal('hide');
              window.location.href = '/thanks-page';
            }
          })
          .catch((error) => {

          })
    }
  },
  mounted() {
    let vm = this;
    $('#flatConsultationModal').on('show.bs.modal', function (e) {
      let id;
      id = $(e.relatedTarget).data('id');
      console.log(id);
      vm.form.pageable_id = id;
    });
  }
}
</script>
